function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.99967 0.333333C10.6797 0.333333 13.6663 3.32667 13.6663 7L13.6638 7.18651C13.5649 10.7804 10.6173 13.6667 6.99967 13.6667C3.32634 13.6667 0.333008 10.68 0.333008 7C0.333008 3.32667 3.32634 0.333333 6.99967 0.333333ZM4.333 8.32001C4.533 8.51335 4.84633 8.51335 5.03966 8.31335L6.99966 6.34668L8.95966 8.31335C9.153 8.51335 9.473 8.51335 9.66633 8.32001C9.86633 8.12001 9.86633 7.80668 9.66633 7.61335L7.353 5.28668C7.25966 5.19335 7.133 5.14001 6.99966 5.14001C6.86633 5.14001 6.73966 5.19335 6.64633 5.28668L4.333 7.61335C4.233 7.70668 4.18633 7.83335 4.18633 7.96001C4.18633 8.09335 4.233 8.22001 4.333 8.32001Z",
  fill: "#547EBD"
});
function SvgArrowUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.49f25284af2f3f6840638433247b63c1.svg";
export { ForwardRef as ReactComponent };